import Blank from "@/layouts/blank.vue"

import ManagementDashboard from "@/pages/admin/management-dashboard/index.vue";


const managementDashboardRoutes = [
    {
        path: "management-dashboard",
        name: "app-admin-management-dashboard",
        component: Blank,
        children: [

            {
                path: "list",
                name: "app-admin-management-dashboard-list",
                component: ManagementDashboard,
            },

        ]
    },
]

export default managementDashboardRoutes